// @react-functional
import { useState, useEffect } from 'react';
import { getArticleStats } from '../../../legislation/page/legislation.api';
import { ArticleStatsResponseType } from '../../../legislation/page/legislation.types';

export const useArticleFetcher = ({ articleId }: { articleId: string }) => {
  const defaultValue = {
    qpc: 0,
    referenceDecisions: 0,
    commentaries: 0,
    parliamentaryQuestions: 0,
  };
  const [articleStats, setArticleStats] = useState<ArticleStatsResponseType>(
    defaultValue,
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedData = await getArticleStats(articleId);
      setIsLoading(false);
      setArticleStats(fetchedData);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { stats: articleStats, loading: isLoading };
};
